module.exports = __webpack_public_path__ + "fontawesome-webfont.1dc35d25e61d819a9c35.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/components-font-awesome/fonts/fontawesome-webfont.ttf?v=4.6.3
// module id = 273
// module chunks = 2